import React from 'react';
import {getBarcodeFromBase64} from "../utils/barcode";

export default function LFCTicket({data, barcodeImage}) {
  return (
      <div className="w-[450px] h-[553px] bg-[#aa2d27] text-white shadow-lg relative overflow-hidden rounded-md">
        {/* Header (black bar) */}
        <div className="flex items-center justify-between p-3">
          {/* Left: LFC logo (placeholder) */}
          <div className="flex items-center space-x-2">
            <img className="w-12 h-12" src="https://lh3.googleusercontent.com/XUIdUSPKbNELpjjJveHFfGLWwZyUrZ9uJ5bnI4kI1fw-reTCCf5XRAsG1doF-8kFx5WyE9Yy4BiLCK454dELklZ2"/>
          </div>
          {/* Right: Ticket Number */}
          <div className="text-right text-l text-white">
            <span className="block leading-none">TICKET NUMBER</span>
            <span className="text-2xl">{data.metadata.supporter_id}</span>
          </div>
        </div>

        {/* Main body (red) */}
        <div className="p-4">
          {/* Title: GENERAL ADMISSION centered */}
          <img src="https://lh3.googleusercontent.com/s10y5hlUtRuiXOIhtAq7aVYVPdzmv-xMVnzAiEtzEsIj-DZR615QPY6acrtXnluHyllLJtB2JmgcT0G1O1K-p0M" alt=""/>

          {/* Row 1: Game + Date */}
          <div className="flex justify-between text-sm mb-3">
            <div>
              <span className="block uppercase text-xs opacity-80">Game</span>
              <span className="text-xl">{data.metadata.next_game}</span>
            </div>
            <div className="text-left">
              <span className="block uppercase text-xs opacity-80">Date</span>
              <span className="text-xl">{data.metadata.next_game_date}</span>
            </div>
          </div>

          {/* Row 2: Entrance, Area, Row, Seat */}
          <div className="flex justify-between text-sm mb-3">
            <div>
              <span className="block uppercase text-xs opacity-80">Entrance</span>
              <span className="text-xl">{data.seat.gate}</span>
            </div>
            <div className="text-left">
              <span className="block uppercase text-xs opacity-80">Area</span>
              <span className="text-xl">{data.seat.section}</span>
            </div>
            <div className="text-left">
              <span className="block uppercase text-xs opacity-80">Row</span>
              <span className="text-xl">{data.seat.row}</span>
            </div>
            <div className="text-left">
              <span className="block uppercase text-xs opacity-80">Seat</span>
              <span className="text-xl">{data.seat.seat}</span>
            </div>
          </div>

          {/* Row 3: Supporter Name (full width) */}
          <div className="text-sm mb-4">
          <span className="block uppercase text-xs opacity-80">
            Supporter Name
          </span>
            <span className="text-2xl">{data.metadata.supporter_name}</span>
          </div>

          {/* QR Code, centered */}
          <div className="flex justify-center">
            <img
                className="rounded-md"
                width="155"
                height="155"
                src={barcodeImage ? `data:image/png;base64,${barcodeImage}` : ''}
                alt="Dynamic Barcode"
            />
          </div>
        </div>
      </div>
  );
}
